import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** July 2026 toolkit */
export const confidenceToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.CONFIDENCE,
  iFrameSrcUrl: '/confidence',
  micrositeUrl: 'confidence',
  title: {
    id: 'confidenceToolkit.title',
    defaultMessage: 'Building Confidence',
    description: 'Microsite page title',
  },
  featureFlag: 'isConfidenceToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/ditching-impostor-syndrome',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
  ],
  page: '202607 confidence',
  trackUTMParams: {
    utm_campaign: 'Jul726',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'Building Confidence',
  },
  shouldHideForInternational: true,
}
